<template>
  <div class="home-container">
    <div class="carousel-container">
      <el-carousel trigger="click" height="300px" type="card">
        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
          <img :src="item.imagePath" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="main-container">
      <div class="side-box">
        <div class="title">
          <img src="@/assets/images/home-title.png" />
        </div>
        <div class="content">
          <div class="btn-channel" v-for="item in channels" @click="handleChannelClick(item)" :key="item.value">
            <span :class="['icon', 'iconfont', `icon-${item.icon}`]"></span>
            {{item.label}}
          </div>
        </div>
      </div>
      <div class="news-box">
        <div class="moudle-title">
          <span class="more">更多+</span>
        </div>
        <!-- <div class="more">
          <a href="/noticeList">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </a>
        </div> -->
        <div class="news-list">
          <ul>
            <li v-for="item in noticeList" :key="item.noticeId" @click="showDetail(item.noticeId)">
              <div class="notice-title">{{item.noticeTitle}}</div>
              <div class="date">{{item.createTime.slice(0,10)}}</div>
            </li>
          </ul>
        </div>

        <!-- <el-pagination
          style="text-align: center;padding: 35px;"
          class="pub-pagination"
          layout="prev, pager, next"
          :total="total"
          :page-size.sync="pageSize"
          :current-page.sync="pageNum"
          @current-change="handleCurrentChange"
        /> -->
      </div>


      <el-dialog
        title="新闻详情"
        :visible.sync="dialogVisible"
        width="1000px"
        @closed="handleClose">
        <article>
          <div class="title">{{noticeDetail.noticeTitle}}</div>
          <div class="date">发布时间：{{noticeDetail.createTime}}</div>
          <el-divider></el-divider>
          <div class="content" v-html="noticeDetail.noticeContent">
          </div>
        </article>
      </el-dialog>
    </div>
  </div>

</template>
<script>
import { listNotice, getNotice } from "api/notice";
export default {
  name: 'HomeIndex',
  data() {
    return {
      carouselList: [],
      noticeList: [],
      dialogVisible: false,
      noticeDetail: {},
      channels: [
        // {label: '我要报名', icon: 'user-check', path: '/examEnroll'},
        {label: '规章制度', icon: 'book', value: '1'},
        {label: '考级简章', icon: 'paper', value: '2'},
        {label: '考级教材', icon: 'class', value: '3'},
        // {label: '题库大纲', icon: 'outline', value: '4'},
        {label: '活动展演', icon: 'picture', value: '5'}
      ],
      noticeId: null,
      pageNum: 1,
      pageSize: 8,
      total: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
    }
  },
  created() {
    this.getNoticeList();
    this.getCarouselList();
  },
  methods: {
    getNoticeList() {
      listNotice({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: '0'
      }).then((res) => {
        this.noticeList = res.rows;
        this.total = res.total
      })
    },
    getCarouselList() {
      let baseUrl = this.baseUrl;
      listNotice({
        pageNum: 1,
        pageSize: 3,
        noticeType: '5',
        status: '0'
      }).then((res) => {
        this.carouselList = res.rows;
        this.carouselList.forEach(function(value,index,data){
          data[index].imagePath = baseUrl  + value.imagePath;
        });
      })
    },
    handleChannelClick(channel) {
      if(channel.path) {
        let routeData = this.$router.resolve({
          path: channel.path
        });
        window.open(routeData.href, '_blank')
      } else {
        this.showNotices(channel.value)
      }
    },
    showNotices(noticeType) {
      let routeData = this.$router.resolve({
        name: 'NoticeList',
        query: {noticeType}
      });
      window.open(routeData.href, '_blank');
    },
    /* reloadNotices(noticeType) {
      this.noticeType = noticeType;
      this.pageNum = 1;
      this.getnoticeList();
    }, */
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getnoticeList();
    },
    showDetail(id) {
      let routeData = this.$router.resolve({ path:`/notice/${id}`});
      window.open(routeData.href, '_blank'); //打开新标签

      /* this.noticeId = id;
      this.dialogVisible = true;
      getNotice(this.noticeId).then((res) => {
        this.noticeDetail = res.data;
      }) */
    },
    handleClose() {
      this.noticeDetail = {};
    }
  }
}
</script>
<style lang="scss" scoped>
$mainColor: #56a4de;
.carousel-container {
  margin: 0 auto;
  margin-top: 55px;
  width: 1200px;
  img {
    width: 100%;
  }
}
.main-container {
  display: flex;
  padding-top: 30px;
  .side-box {
    width: 288px;
    flex-shrink: 0;
    .title {
      background-color: #ba0900;
      text-align: center;
      padding: 20px 0;
      img {
        width: 176px;
      }
    }
    .content {
      height: 320px;

      .btn-channel {
        height: 63px;
        line-height: 63px;
        margin: 0 auto;
        text-align: center;
        background-image: url('~@/assets/images/banner-red.png');
        color: #ffffff;
        cursor: pointer;
        font-size: 24px;
        .iconfont {
          font-size: 24px;
        }
        &:hover {
          background-image: url('~@/assets/images/banner-yellow.png');
          color: #ba0900;
        }
      }
    }
  }
  .news-box {
    width: 100%;
    margin-left: 60px;
    >div {
      float: left;
      height: 30px;
    }
    .moudle-title {
      width: 100%;
      background-image: url('~@/assets/images/news-title-bg.png');
      background-size: 100% 100%;
      height: 83px;
      text-align: right;
      padding-right: 50px;
      .more {
        line-height: 83px;
        font-size: 18px;
        color: #FFFFFF;
        cursor: pointer;
        /* a {
          font-size: 18px;
          color: #FFFFFF;
          text-decoration: none;
          &:link, &:visited {
            color: #FFFFFF;
          }
        } */
      }
    }

    .news-list {
      width: 858px;
      ul {
        display: block;
        padding-left: 24px;
        padding-top: 10px;
        padding-right: 15px;
        background: #f9f8f8;
        height: 540px;
        li {
          display: flex;
          position: relative;
          height: 66px;
          line-height: 66px;
          color: #0c1f4a;
          font-size: 20px;
          &::before {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            background: #333;
            top: calc(50% - 4px);
          }
          .notice-title {
            padding-left: 20px;
            width: 85%;
            cursor: pointer;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .date {
            width: 15%;
            text-align: right;
          }
        }
      }
    }

    .pub-pagination {
      margin: 0 auto;
      width: 100%;
    }
  }

  article {
    .title {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }
    .date {
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>
